var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"card",staticClass:"card",style:({ top: ((_vm.isMove ? _vm.y : _vm.calcY()) + "px") }),attrs:{"data-state":_vm.isMove ? 'move' : _vm.state}},[_c('div',{ref:"pan",class:['pan-area2 opacity']},[_c('div',{ref:"bar",staticClass:"bar",style:({ backgroundColor: _vm.barColor })})]),_c('div',{class:[
      'contents h-screen overflow-hidden rounded-t-xl',
      _vm.isSwipeOpen
        ? 'overflow-scroll bg-white'
        : 'overflow-hidden bg-primary-100' ],attrs:{"id":"swipeable-bottom-sheet"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }